import { Injectable } from '@angular/core';
import {
  getEndpoint,
  getCurrentUser,
} from 'src/app/core/services/functions.service';
import { RequestsService } from 'src/app/core/services/requests.service';
import { HttpClient, HttpHeaders } from '@angular/common/http';

import Swal from 'sweetalert2';

@Injectable({
  providedIn: 'root',
})
export class VisorService {
  constructor(
    private _RequestsService: RequestsService,
    private http: HttpClient
  ) {}

  URL_BASE = getEndpoint('VISOR_ENDPOINT');
  URL_BASE2 = getEndpoint('WEB_LOGIC_API');
  user: any;
  c_emp: string;
  numero: any;
  otpEnviada: boolean = false;
  codigoEnviado: boolean = false;
  cargar: boolean = false;
  aprobado: boolean = false;
  intentos: number = 0;
  otp: any;

  documents_types = async () => {
    try {
      let result = this._RequestsService.get(
        `${this.URL_BASE2}/v1/JA/causal/TQ`
      );
      return result;
    } catch (error) {
      return error;
    }
  };
  modo_c = async (doc, n_ide) => {
    try {
      let id: any = await this.internal_id(n_ide);
      const vendedor = await getCurrentUser();
      let result = await this._RequestsService.get(
        `${this.URL_BASE}/v1/JA/client/${n_ide}?internal_id=${id.data.internal_id}&origen=VISOR_WEB&agency=${vendedor.c_age_trabajo}&vendedor=${vendedor.nombre_usuario}&tipo_doc=${doc}&canal_venta=distancia&usuario=${vendedor.usuario_aplicativo}&programa=VISOR_WEB&cod_vendedor=`
      );
      result.data.internal_id = id.data.internal_id;
      return result;
    } catch (error) {
      return error;
    }
  };
  internal_id = async (cedula) => {
    try {
      let result = await this._RequestsService.postLikeJSON(
        `${this.URL_BASE}/v1/JA/client?origin=VISOR_WEB&source=VISOR_WEB&field=identification&value=${cedula}`,
        {}
      );
      return result;
    } catch (error) {
      return error;
    }
  };

  modo_e = async (body, n_ide) => {
    try {
      let result = await this._RequestsService.postLikeJSON(
        `${this.URL_BASE}/v1/JA/cliente/${n_ide}`,
        body
      );
      return result;
    } catch (error) {
      return error;
    }
  };

  modal_otp_new_habeas(telefono) {
    return new Promise((resolve, reject) => {
      Swal.fire({
        title: `Confirmar número de celular`,
        html: `El código de verificación será enviado al número <strong>${telefono}</strong> <br><br> ¿Este número es el de su cliente?`,
        confirmButtonText: 'Sí, es su número',
        confirmButtonColor: '#00ABB0',
        showCancelButton: true,
        cancelButtonText: 'No, debo cambiarlo',
        cancelButtonColor: '#D8232A',
        heightAuto: false,
        allowOutsideClick: false,
        customClass: {
          cancelButton: 'swal-btn-custom',
          confirmButton: 'swal-btn-custom',
        },
      }).then((result) => {
        if (result.value) {
          resolve(true);
        } else {
          resolve(false);
        }
      });
    });
  }

  sendOtp(informacion) {
    return this.http.post<any>(
      getEndpoint('EPIK_OTP') + `/v1/JA/generar/OTP`,
      informacion
    );
  }

  funcion_enviar_otp(cedula, mobile, email, proceso) {
    const vendedor = getCurrentUser();

    return new Promise((resolve, reject) => {
      let body = {
        num: "", 
        n_ide: cedula,
        mobile: mobile,
        email: email,
        tipo: proceso,
        agest: "",
        codest: "",
        ageop: "",
        perop: "",
        numop: "",
        programa: "VISOR_WEB",
        usuario_aplicacion: vendedor.usuario_aplicativo,
        proceso_ing: "CREDITO",
      };
      this.sendOtp(body).subscribe((resp) => {
        resolve(resp);
      });
    });
  }

  funcion_validar_otp(otpid, pin, proceso) {
    return new Promise((resolve, reject) => {
      this.validarOtp(otpid, pin, proceso).subscribe((resp) => {
        resolve(resp);
      });
    });
  }

  validarOtp(otpId, pin, proceso) {
    return this.http.get<any>(
      `${getEndpoint('VALIDAR_OTP')+`/v1/JA/validar/OTP/${otpId}/${pin}/${proceso}`}`
    );
  }

  async funcion_desmaterializar_new(cedula, mobile, email, otp) {
    try {
      const fechaHora = new Date();
      const dia = fechaHora.getDate();
      const mes = fechaHora.getMonth() + 1;
      const anno = fechaHora.getFullYear();
      const fecha = fechaHora.toLocaleDateString();
      const vendedor = await getCurrentUser();
      let body = {
        usuario: vendedor.usuario_aplicativo,
        programa: 'VISOR_WEB',
        body: {
          Clientes: [
            {
              TipoDocumento: 'CC',
              TipoDocumentoHom: '1',
              Documento: cedula,
              NombreCliente: '',
              ApellidoCliente: '',
              CiudadDocumento: '',
              DepartamentoDocumento: '',
              Correo: email,
              Telefono: mobile,
              IndicadorCodeudor: 0,
            },
          ],
          Fecha: fechaHora,
          Dia: Number(dia),
          Mes: Number(mes),
          Anno: Number(anno),
          FirmaCliente: null,
          FirmaCodeudor: null,
          CodigoOtp: otp,
          CamposCrediJamar: [
            {
              Agencia: vendedor.c_age_trabajo,
              Vendedor: vendedor.usuario_aplicativo,
              Fecha: fecha,
              NoOP: '',
              Numeroconsecutivo: '',
            },
          ],
          Pais: '1',
          Firma: 'SI',
          FechaFirma: fechaHora,
        },
      };
      const resp = await this
        .desmaterializarNew(body)
        .toPromise();
      return resp;
    } catch (error) {
      console.error(error);
    }
  }

  desmaterializarNew(informacion) {
    return this.http.post<any>(
      getEndpoint('DESMATERIALIZAR_HABEAS_NUEVO')+`/v1/JA/epik/habeasdata/nuevo`,
      informacion
    );
  }
}
